import { INIT, SUCCESS, LOADING, ERROR } from "../../../utils/constants";
import {
  GET_AZURE_METRICS_REQUEST,
  GET_AZURE_METRICS_REQUEST_SUCCESS,
  GET_AZURE_METRICS_REQUEST_ERROR,
} from "./constant";

const initialState = {
  phase: INIT,
  azureMetricsRequestList: null,
  error: null,
};

/**
 * User Reducer
 * @param {Object} state
 * @param {Object} action
 */

export function AzureMetricsRequestStore(state = initialState, action) {
  switch (action.type) {
    case GET_AZURE_METRICS_REQUEST:
      return {
        ...state,
        phase: LOADING,
      };
    case GET_AZURE_METRICS_REQUEST_SUCCESS:
      return {
        ...state,
        phase: SUCCESS,
        azureMetricsRequestList: action.data,
        error: null,
      };
    case GET_AZURE_METRICS_REQUEST_ERROR:
      return { ...state, phase: ERROR, error: action.error };

    default:
      return state;
  }
}
